<router-outlet />

<!-- Diálogo de confirmación global (reemplaza window.confirm) -->
<ui-confirm />
